






















import Vue from 'vue';
import Component from "vue-class-component";
import VueUserName from '@/components/user-name.vue';
import { Prop } from "vue-property-decorator";
import { Guide } from '@/types/models';
import { default as mixins } from '../mixins/user';

@Component({
  mixins: [ mixins ],
  components: {
    'vue-user-name': VueUserName
  }
})
export default class VueMetadata extends Vue {
  @Prop()
  readonly guide!: Guide;
}
